import { render, staticRenderFns } from "./GameBackground.vue?vue&type=template&id=9e9f6878&scoped=true"
import script from "./GameBackground.vue?vue&type=script&lang=ts"
export * from "./GameBackground.vue?vue&type=script&lang=ts"
import style0 from "./GameBackground.vue?vue&type=style&index=0&id=9e9f6878&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9f6878",
  null
  
)

export default component.exports